import React, { useState, useRef, useMemo } from 'react';
import { motion, AnimatePresence, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface GalleryImage {
  id: number;
  title: string;
  category: string;
  src: string;
  description?: string;
}

const Gallery: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState<GalleryImage | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>('all');
  const [hoveredImage, setHoveredImage] = useState<number | null>(null);
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  
  // Placeholder data - in a real app, this would come from an API or CMS
  const images: GalleryImage[] = [
    {
      id: 1,
      title: 'Tokyo University Campus',
      category: 'universities',
      src: '../../../images/universities/tokyo.jpeg',
      description: 'The historic main campus of Tokyo University during cherry blossom season, showcasing the perfect blend of traditional architecture and modern educational facilities.'
    },
    
    // {
    //   id: 2,
    //   title: 'Cherry Blossom Season',
    //   category: 'culture',
    //   src: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    //   description: 'Students enjoying hanami (cherry blossom viewing) in a local park, a traditional cultural activity that brings everyone together each spring.'
    // },
   
    
    {
      id: 16,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/4.jpeg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 17,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/5.jpeg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 18,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/6.jpeg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 19,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/7.jpeg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 20,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/8.jpeg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 21,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/9.jpeg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 22,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/10.jpeg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 23,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/12.jpeg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 24,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/13.jpeg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 25,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/14.jpg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 26,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/15.jpg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    
    {
      id: 4,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/1.jpg',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 2,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/2.jpg',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 30,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/3.JPG',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 31,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/4.webp',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 32,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/5.webp',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 33,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/6.jpeg',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 34,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/7.jpeg',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 35,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/8.jpeg',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 36,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/9.jpeg',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 37,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/10.jpeg',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 38,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/11.jpeg',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    {
      id: 39,
      title: 'Japanese Culture',
      category: 'culture',
      src: '../../../images/culture/12.jpeg',
      // description: 'A cultural field trip to Kinkaku-ji (Golden Pavilion) in Kyoto, one of Japan\'s most visited temples and a UNESCO World Heritage site.'
    },
    // {
    //   id: 5,
    //   title: 'Graduation Ceremony',
    //   category: 'education',
    //   src: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    //   description: 'Proud international graduates at a Japanese university ceremony, celebrating their academic achievements and new beginnings.'
    // },
    {
      id: 40,
      title: 'Japanese Lifestyle',
      category: 'lifestyle',
      src: '../../../images/lifestyle/1.webp',
      // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    },
    {
      id: 41,
      title: 'Japanese Lifestyle',
      category: 'lifestyle',
      src: '../../../images/lifestyle/2.webp',
      // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    },
    {
      id: 42,
      title: 'Japanese Lifestyle',
      category: 'lifestyle',
      src: '../../../images/lifestyle/3.webp',
      // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    },
    // {
    //   id: 43,
    //   title: 'Japanese Lifestyle',
    //   category: 'lifestyle',
    //   src: '../../../images/lifestyle/4.jpg',
    //   // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    // },
    {
      id: 44,
      title: 'Japanese Lifestyle',
      category: 'lifestyle',
      src: '../../../images/lifestyle/5.jpg',
      // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    },
    {
      id: 45,
      title: 'Japanese Lifestyle',
      category: 'lifestyle',
      src: '../../../images/lifestyle/6.jpg',
      // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    },
    {
      id: 46,
      title: 'Japanese Lifestyle',
      category: 'lifestyle',
      src: '../../../images/lifestyle/7.jpg',
      // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    },
    {
      id: 47,
      title: 'Japanese Lifestyle',
      category: 'lifestyle',
      src: '../../../images/lifestyle/8.jpg',
      // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    },
    {
      id: 48,
      title: 'Japanese Lifestyle',
      category: 'lifestyle',
      src: '../../../images/lifestyle/9.jpg',
      // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    },
    {
      id: 49,
      title: 'Japanese Lifestyle',
      category: 'lifestyle',
      src: '../../../images/lifestyle/10.jpeg',
      // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    },
    {
      id: 50,
      title: 'Japanese Lifestyle',
      category: 'lifestyle',
      src: '../../../images/lifestyle/11.png',
      // description: 'The vibrant nightlife of Tokyo\'s Shinjuku district, where many international students explore entertainment options after classes.'
    },
    // {
    //   id: 7,
    //   title: 'Traditional Tea Ceremony',
    //   category: 'culture',
    //   src: 'https://images.unsplash.com/photo-1547592180-0173f5c46978?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    //   description: 'Students learning the ancient art of the Japanese tea ceremony (sado), a cultural tradition that embodies harmony, respect, purity, and tranquility.'
    // },
    {
      id: 8,
      title: 'Osaka University Library',
      category: 'universities',
      src: '../../../images/universities/osaka.jpg',
      description: 'The modern library facilities at Osaka University, offering students a quiet space for research and study with cutting-edge resources.'
    },
    // {
    //   id: 9,
    //   title: 'Student Housing',
    //   category: 'lifestyle',
    //   src: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    //   description: 'Comfortable and affordable student accommodation options, designed to make international students feel at home while studying in Japan.'
    // },
    // {
    //   id: 10,
    //   title: 'Mt. Fuji Excursion',
    //   category: 'culture',
    //   src: 'https://images.unsplash.com/photo-1545569341-9eb8b30979d9?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    //   description: 'An organized student trip to Mt. Fuji, Japan\'s highest peak and an iconic cultural symbol, providing unforgettable memories.'
    // },
    // {
    //   id: 11,
    //   title: 'Modern Research Laboratory',
    //   category: 'education',
    //   src: 'https://images.unsplash.com/photo-1581093588401-fbb62a02f120?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    //   description: 'State-of-the-art research facilities where international students participate in groundbreaking scientific studies.'
    // },
    // {
    //   id: 12,
    //   title: 'Tokyo Skyline',
    //   category: 'lifestyle',
    //   src: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    //   description: 'The breathtaking Tokyo skyline view that many students enjoy from observation decks around the city.'
    // },
    {
      id: 13,
      title: 'Kyoto University',
      category: 'universities',
      src: '../../../images/universities/kyoto.jpg',
      description: 'A historic institution combining traditional values with modern research capabilities.'
    },
    {
      id: 60,
      title: 'Tohoku University',
      category: 'universities',
      src: '../../../images/universities/tohoku.jpg',
      description: 'Pioneering research institution with strong emphasis on practical applications.'
    },
    {
      id: 61,
      title: 'Nagoya University',
      category: 'universities',
      src: '../../../images/universities/nagoya.jpg',
      description: 'Innovative university known for its research in advanced materials and life sciences.'
    },
    {
      id: 62,
      title: 'Tokyo Institute of Technology',
      category: 'universities',
      src: '../../../images/universities/tokyo institute.png',
      description: "Japan's leading science and technology university, driving innovation in STEM fields."
    },
     {
      id: 63,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/2.JPG',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
    {
      id: 15,
      title: 'Japanese Language Class',
      category: 'education',
      src: '../../../images/education/3.jpg',
      // description: 'International students participating in an immersive Japanese language class, practicing conversation skills with native speakers.'
    },
  ];
  
  const categories = ['all', 'universities', 'culture', 'education', 'lifestyle'];
  
  // Use useMemo to memoize filtered images
  const filteredImages = useMemo(() => {
    return activeCategory === 'all' 
      ? images 
      : images.filter(img => img.category === activeCategory);
  }, [activeCategory]);

  React.useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  return (
    <div className="pt-24 pb-16 mt-10 min-h-screen bg-gradient-to-b from-blue-50 via-white to-pink-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary relative inline-block">
            Our Gallery
            <motion.div
              className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-primary to-secondary"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            ></motion.div>
          </h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Explore our collection of images showcasing student life, universities, cultural experiences, and more in Japan.
          </p>
        </motion.div>
        
        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-16">
          {categories.map((category, index) => (
            <motion.button
              key={category}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.1 * index }}
              className={`px-6 py-3 rounded-full transition-all duration-300 font-medium ${
                activeCategory === category
                  ? 'bg-gradient-to-r from-primary to-secondary text-white shadow-lg shadow-primary/20'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }`}
              onClick={() => setActiveCategory(category)}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </motion.button>
          ))}
        </div>
        
        {/* Gallery Grid */}
        <motion.div 
          ref={ref}
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: {
                staggerChildren: 0.05,
                when: "beforeChildren"
              }
            }
          }}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8"
        >
          {filteredImages.map((image) => (
            <motion.div
              key={image.id}
              layout
              variants={{
                hidden: { opacity: 0, scale: 0.8 },
                visible: { opacity: 1, scale: 1 }
              }}
              initial="hidden"
              animate="visible"
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.3 }}
              className="aspect-[4/3] overflow-hidden rounded-2xl cursor-pointer relative group bg-white shadow-lg border border-gray-100"
              onClick={() => setSelectedImage(image)}
              onMouseEnter={() => setHoveredImage(image.id)}
              onMouseLeave={() => setHoveredImage(null)}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10"></div>
              
              <motion.img 
                src={image.src} 
                alt={image.title}
                initial={{ opacity: 1 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110"
              />
              
              <motion.div 
                className="absolute inset-0 flex flex-col justify-end p-5 z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                initial={{ opacity: 0, y: 20 }}
                animate={hoveredImage === image.id ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.3 }}
              >
                <span className="inline-block px-2 py-1 bg-gradient-to-r from-primary to-secondary text-white text-xs font-medium rounded-full mb-2 w-fit">
                  {image.category.charAt(0).toUpperCase() + image.category.slice(1)}
                </span>
                <h3 className="text-white text-lg font-semibold">{image.title}</h3>
                <div className="mt-2 bg-white/20 backdrop-blur-sm rounded-lg px-3 py-2 text-white text-sm">
                  Click to view full image
                </div>
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
        
        {filteredImages.length === 0 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-20"
          >
            <div className="inline-block p-5 rounded-full bg-gray-100 mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">No images found</h3>
            <p className="text-gray-500">There are no images in this category yet. Please check back later or select another category.</p>
          </motion.div>
        )}
        
        {/* Lightbox */}
        <AnimatePresence>
          {selectedImage && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90 backdrop-blur-md"
              onClick={() => setSelectedImage(null)}
            >
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
                className="relative max-w-5xl w-full rounded-2xl overflow-hidden bg-white shadow-2xl"
                onClick={e => e.stopPropagation()}
              >
                <div className="flex flex-col md:flex-row h-full">
                  <div className="md:w-3/5 h-[300px] md:h-[600px] relative">
                    <img 
                      src={selectedImage.src} 
                      alt={selectedImage.title} 
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="md:w-2/5 p-6 md:p-8 flex flex-col">
                    <div className="flex items-center justify-between mb-4">
                      <span className="px-3 py-1 bg-gradient-to-r from-primary to-secondary text-white text-xs font-medium rounded-full">
                        {selectedImage.category.charAt(0).toUpperCase() + selectedImage.category.slice(1)}
                      </span>
                      <button
                        className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-gray-200 transition-colors"
                        onClick={() => setSelectedImage(null)}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-3">{selectedImage.title}</h3>
                    <p className="text-gray-600 mb-6 flex-grow">
                      {selectedImage.description || "No description available for this image."}
                    </p>
                    <div className="mt-auto">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-2">
                          <button className="p-2 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                            </svg>
                          </button>
                          <button className="p-2 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                              <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                            </svg>
                          </button>
                        </div>
                        <button
                          className="px-4 py-2 bg-gradient-to-r from-primary to-secondary text-white rounded-lg hover:shadow-lg hover:scale-[1.02] transition-all duration-300"
                          onClick={() => setSelectedImage(null)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Gallery; 